module.exports = __webpack_public_path__ + "img/linkthings_logo.09ce0f9a.svg";